// event handlers
// import ref from './_state';
import fadeBtns from './update-fade-btns';
import chartNote from './update-footnote';
import chartTitle from './update-chart-title';
import update from './_update';
import c from './u-colours';
// import opts from './_opts';
import pointSeries from './render-point-series';

export default function (ref) {

    // NAV next and prev
    d3.select('#js-next')
        .on('click', function() {
            if(ref.activeIndex !== ref.uniNames.length-1) ref.activeIndex++;
            fadeBtns(ref);
            update(ref);
        });
    d3.select('#js-prev')
        .on('click', function() {
            if(ref.activeIndex !== 0) ref.activeIndex--;
            fadeBtns(ref);
            update(ref);
        });
    // clear typeahead input
    d3.select('#js-typeahead-clear')
        .on('click', function() {
            jQuery('.typeahead').typeahead('val', '');
            jQuery('.typeahead').typeahead('open');
        });

    // TEMP
    // ref.highlightColour = c.crimson;

    // change scatter chart
    d3.select('#js-btn-salary')
        .on('click', function() {
            pointSeries(ref, ref.opts.salary);
            chartNote(ref.opts.salary.footnote);
            chartTitle(ref.opts.salary.title);

            d3.selectAll('.js-btn-chart').transition()
                .style('opacity', 1)
                .style('pointer-events', 'auto');
            d3.select(this).transition()
                .style('opacity', 0.4)
                    .style('pointer-events', 'none');

            d3.select('#js-square1 rect.thed3-square').transition().style('fill', ref.opts.salary.squareChart.fColour);
            d3.select('#js-square2 rect.thed3-square').transition().style('fill', c.grey5);
            d3.select('#js-square3 rect.thed3-square').transition().style('fill', c.grey5);
            d3.select('#js-square4 rect.thed3-square').transition().style('fill', c.grey5);
        });

    d3.select('#js-btn-ref')
        .on('click', function() {
            pointSeries(ref, ref.opts.ref);
            chartNote(ref.opts.ref.footnote);
            chartTitle(ref.opts.ref.title);

            d3.selectAll('.js-btn-chart').transition()
                .style('opacity', 1)
                .style('pointer-events', 'auto'); 
            d3.select(this).transition()
                .style('opacity', 0.4)
                .style('pointer-events', 'none');

            d3.select('#js-square1 rect.thed3-square').transition().style('fill', c.grey5);
            d3.select('#js-square2 rect.thed3-square').transition().style('fill', ref.opts.ref.squareChart.fColour);
            d3.select('#js-square3 rect.thed3-square').transition().style('fill', c.grey5);
            d3.select('#js-square4 rect.thed3-square').transition().style('fill', c.grey5);
        });

    d3.select('#js-btn-nss')
        .on('click', function() {
            pointSeries(ref, ref.opts.nss);
            chartNote(ref.opts.nss.footnote);
            chartTitle(ref.opts.nss.title);

            d3.selectAll('.js-btn-chart').transition()
                .style('opacity', 1)
                .style('pointer-events', 'auto'); 
            d3.select(this).transition()
                .style('opacity', 0.4)
                .style('pointer-events', 'none');

            d3.select('#js-square1 rect.thed3-square').transition().style('fill', c.grey5);
            d3.select('#js-square2 rect.thed3-square').transition().style('fill', c.grey5);
            d3.select('#js-square3 rect.thed3-square').transition().style('fill', ref.opts.nss.squareChart.fColour);
            d3.select('#js-square4 rect.thed3-square').transition().style('fill', c.grey5);
        });

    d3.select('#js-btn-students')
        .on('click', function() {
            pointSeries(ref, ref.opts.students);
            chartNote(ref.opts.students.footnote);
            chartTitle(ref.opts.students.title);

            d3.selectAll('.js-btn-chart').transition()
                .style('opacity', 1)
                .style('pointer-events', 'auto'); 
            d3.select(this).transition()
                .style('opacity', 0.4)
                .style('pointer-events', 'none');

            d3.select('#js-square1 rect.thed3-square').transition().style('fill', c.grey5);
            d3.select('#js-square2 rect.thed3-square').transition().style('fill', c.grey5);
            d3.select('#js-square3 rect.thed3-square').transition().style('fill', c.grey5);
            d3.select('#js-square4 rect.thed3-square').transition().style('fill', ref.opts.students.squareChart.fColour);
        });

}